/* @flow */

import React from 'react';
import { useSelector } from 'react-redux';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import ButtonComponent from 'components/buttons/button';
import CompanyLookupDebtorComponent from 'components/companyLookupV2/debtors';
import DatePickerComponent from 'components/formFields/dates/datePicker';
import FormErrorsComponent from 'components/formErrors';
import InputAmountComponent from 'components/formatters/inputAmount';
import IntlMessageComponent from 'components/formatters/intlMessage';
import MandatoryFormFieldsComponent from 'components/form/mandatory';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import UploadFieldComponent from 'components/formFields/upload';

import { ROLE_ISO } from 'constants/companyRoles';

type OfferTabXmlViewComponentProps = {
  defaults: LeadOfferDefaults,
  errors: Map<string,?string>,
  file: ?File,
  formErrors: string[],
  isProcessing: boolean,
  filename: string;
  goBack: () => void,
  changeToRegularFlow: () => void,
  handleDocumentSelect: () => void;
  handleDocumentRemove: () => void;
  uploadFile: () => void;
}

export default function OfferTabXmlViewComponent(props: OfferTabXmlViewComponentProps) {
  const activeCompanyRole = useSelector(state => state.auth.user !== null ? state.auth.user.activeCompany.role : 0);
  const defaultFieldOptions = {
    margin: 'normal', fullWidth: true
  };
  return (
    <React.Fragment>
      <FormErrorsComponent formErrors={props.formErrors} />

      <Typography variant="body1" gutterBottom>
        <IntlMessageComponent id="component.offer.tabxml.intro" />
      </Typography>

      <Box mt={1}>
        <Grid container spacing={6} alignItems="stretch">
          <Grid item xs={12} md={6}>
            <Box mt={1}>
              <UploadFieldComponent
                disabled={props.isProcessing}
                displayProps={defaultFieldOptions}
                filename={props.filename}
                isRequired={true}
                label={`offer.xml.upload`}
                successHandler={props.handleDocumentSelect}
                removeHandler={props.handleDocumentRemove}
                acceptFormats={"text/xml"}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={5} bgcolor="#eaeaea" >
              <Box>
                <IntlMessageComponent id="offer.regularflow.explanation" /><br /><br />
              </Box>
              <Box display="flex" justifyContent="center">
                <ButtonComponent
                  color="primary"
                  variant="contained"
                  isProcessing={props.isProcessing}
                  onClick={props.changeToRegularFlow}
                ><IntlMessageComponent id="offer.button.regularflow" /></ButtonComponent>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box mt={5}>
        {props.enableBackButton &&
          <Box component="span" mr={1}>
            <ButtonComponent
              color="primary"
              variant="outlined"
              isProcessing={props.isProcessing}
              onClick={props.goBack}
            ><IntlMessageComponent id="general.button.back.label" /></ButtonComponent>
          </Box>
        }

        <Box component="span" mr={1}>
          <ButtonComponent
            color="primary"
            variant="contained"
            isProcessing={props.isProcessing}
            disabled={props.file === null}
            onClick={props.uploadFile}
          ><IntlMessageComponent id="general.button.validate.label" /></ButtonComponent>
        </Box>
        <MandatoryFormFieldsComponent />

      </Box>
    </React.Fragment>
  );
}